// @flow

export const CAMPOS_SITUACAO_SEFAZ_NFE = [
  { label: 'Autorizado', name: 'autorizado' },
  { label: 'Cancelado', name: 'cancelado' },
  { label: 'Denegado', name: 'denegado' },
  { label: 'Não Consta', name: 'nao_consta' },
];
